import React from 'react';
import { Container, Typography, Button, Box } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: theme.spacing(4),
  },
  card: {
    background: theme.palette.tabHeaderBackground,
    borderRadius: 20,
    padding: theme.spacing(6, 5),
    textAlign: 'center',
    maxWidth: 480,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  iconWrapper: {
    width: 88,
    height: 88,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(1),
    backgroundColor: '#eff6ff',
  },
  icon: {
    fontSize: 44,
    color: '#3b82f6',
  },
  code: {
    fontWeight: 700,
    fontSize: '3rem',
    lineHeight: 1,
    letterSpacing: '-1px',
    color: '#3b82f6',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.15rem',
    marginTop: theme.spacing(0.5),
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
    lineHeight: 1.6,
    maxWidth: 360,
  },
  button: {
    marginTop: theme.spacing(1.5),
    borderRadius: 20,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    boxShadow: 'none',
    fontWeight: 600,
    color: '#fff !important',
  },
}));

const NotFound = () => {
  const classes = useStyles();
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  return (
    <Container className={classes.container}>
      <Box className={classes.card}>
        <Box className={classes.iconWrapper}>
          <ErrorOutlineIcon className={classes.icon} />
        </Box>

        <Typography className={classes.code}>404</Typography>

        <Typography variant="h6" className={classes.title}>
          Página não encontrada
        </Typography>

        <Typography className={classes.description}>
          A página que você está procurando não existe ou foi movida. Verifique o endereço digitado
          ou volte ao início.
        </Typography>

        <Button
          className={classes.button}
          variant="contained"
          style={{ backgroundColor: primary }}
          href="/"
        >
          Voltar ao início
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;
